module.exports = __webpack_public_path__ + "img/cursov2.3f59412f.png";